var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container card-full-width-mobile mt-3 mt-md-9"},[(
      !this.$store.getters.profile ||
      !this.$store.getters.locale ||
      !this.$store.state.data.content
    )?_c('loader'):_c('div',[_c('b-card',{staticClass:"mb-2 referrals-whole-card",attrs:{"tag":"article"}},[_c('div',{staticClass:"mx-lg-9 mx-md-6 pt-md-7 pt-4"},[_c('referral-welcome'),_c('Form'),_c('how-it-works'),_c('gifts')],1)]),_c('most-asked-questions')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }